import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/k8s_training_web/k8s_training_web/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 TASK: Install Bookinfo Demo Application`}</h2>
    <p>{`In this part, we will be using the sample BookInfo Application that comes as default with Istio code base. As mentioned above, the application that is composed of four microservices, written in different languages for each of its microservices namely Python, Java, Ruby, and Node.js. The default application doesn’t use a database and all the microservices store their data in the local file system.`}</p>
    <img {...{
      "src": "./../images/bookinfo.png",
      "alt": "kiali"
    }}></img>
    <p>{`Envoys are deployed as sidecars on each microservice. Injecting Envoy into your microservice means that the Envoy sidecar would manage the ingoing and outgoing calls for the service. To inject an Envoy sidecar to an existing microservice configuration, do:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`kubectl apply -f ./istio-1.27.3/samples/bookinfo/platform/kube/bookinfo.yaml
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-output"
      }}>{`> service/details created
> serviceaccount/bookinfo-details created
> deployment.apps/details-v1 created
> service/ratings created
> ...
`}</code></pre>
    <p>{`After a few minutes, you should now have your Kubernetes Pods running and have an Envoy sidecar in each of them alongside the microservice. The microservices are `}<strong parentName="p">{`productpage, details, ratings, and reviews`}</strong>{`. Note that you’ll have three versions of the reviews microservice.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`kubectl get pods 
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-output"
      }}>{`> NAME                                        READY     STATUS    RESTARTS   AGE
> details-v1-1520924117-48z17                 2/2       Running   0          6m
> productpage-v1-560495357-jk1lz              2/2       Running   0          6m
> ratings-v1-734492171-rnr5l                  2/2       Running   0          6m
> reviews-v1-874083890-f0qf0                  2/2       Running   0          6m
> reviews-v2-1343845940-b34q5                 2/2       Running   0          6m
> reviews-v3-1813607990-8ch52                 2/2       Running   0          6m
`}</code></pre>
    <h2>{`🚀 TASK: Expose the Application via Ingress Gateway`}</h2>
    <p>{`The components deployed on the service mesh by default are not exposed outside the cluster. External access to individual services so far has been provided by creating an external load balancer or node port on each service.`}</p>
    <p>{`An Ingress Gateway resource can be created to allow external requests through the Istio Ingress Gateway to the backing services.`}</p>
    <p>{`Create an Istio ingress gateway to access your services over a public IP address.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`kubectl apply -f ./istio-1.27.3/samples/bookinfo/networking/bookinfo-gateway.yaml
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-output"
      }}>{`> gateway.networking.istio.io/bookinfo-gateway created
> virtualservice.networking.istio.io/bookinfo created
`}</code></pre>
    <h2>{`🚀 TASK: Open Bookinfo`}</h2>
    <p>{`You can open the webpage by forwarding a local port to the service in your Cluster.`}</p>
    <p>{`Execute this in a separate Terminal Window/Tab in order to be able to access the web page:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`kubectl port-forward --namespace istio-system $(kubectl get po -n istio-system | grep istio-ingressgateway| \\awk '{print $1;}') 8080:8080 
`}</code></pre>
    <p>{`Now you can access your application via `}<a parentName="p" {...{
        "href": "http://localhost:8080/productpage?u=normal"
      }}>{`http://localhost:8080/productpage`}</a></p>
    <p>{`If you refresh the page multiple times, you’ll see that the `}<em parentName="p">{`reviews`}</em>{` section of the page changes. That’s because there are 3 versions of `}<strong parentName="p">{`reviews`}</strong><em parentName="p">{`(reviews-v1, reviews-v2, reviews-v3)`}</em>{` deployment for our `}<strong parentName="p">{`reviews`}</strong>{` service. Istio’s load-balancer is using a round-robin algorithm to iterate through the 3 instances of this service`}</p>
    <h5>{`V1 - No ratings`}</h5>
    <img {...{
      "src": "./../images/none.png",
      "alt": "productpage"
    }}></img>
    <h5>{`V2 - Ratings with black stars`}</h5>
    <img {...{
      "src": "./../images/black.png",
      "alt": "productpage"
    }}></img>
    <h5>{`V3- Ratings with red stars`}</h5>
    <img {...{
      "src": "./../images/red.png",
      "alt": "productpage"
    }}></img>
    <h2>{`Sidecar injection`}</h2>
    <p>{`In Kubernetes, a sidecar is a utility container in the pod, and its purpose is to support the main container. For Istio to work, Envoy proxies must be deployed as sidecars to each pod of the deployment. There are two ways of injecting the Istio sidecar into a pod: manually using the istioctl CLI tool or automatically using the Istio Initializer. In this exercise, we will use the manual injection. Manual injection modifies the controller configuration, e.g. deployment. It does this by modifying the pod template spec such that all pods for that deployment are created with the injected sidecar.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      